module.exports = __webpack_public_path__ + "img/Logo trasparente white.87aaf7f3.png";